import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";
import * as React from "react";
import CategoryList from "../categories/categoryList";
import Company from "../company/company";
import ColorsSizes from "../config/color_sizes";
import Highlights from "../highlights/highlights";
import UserList from "../user/userList";
import "./tabDashboard.css";
import { useDispatch } from "react-redux";
import { titleSetRef } from "../../redux/titleRedux";
import { useCompany } from "../../components/context/CompanyContext";
import StoreList from "../store/storeList";
import CartList from "../carts/cartList";
import UserRepList from "../userRep/userRepList";
import AccessControl from "../access/accessControl";
import PaymentTypeList from "../paymentType/paymentTypeList";
import VirtualOnTryList from "../virtualOnTry/virtualOnTryList";
import CardOperator from "../cardOperator/cardOperator";
import System from "../system/System";


const GroupTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: 13,
  minHeight: 38,
  color: "rgba(0,0,0,0.6)",
  "&:hover": { color: "#EE8253", opacity: 1 },
  "&.Mui-selected": { color: "#EE8253", fontWeight: 700 },
}));

const SubTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: 12,
  minHeight: 32,
  color: "rgba(0,0,0,0.7)",
  "&:hover": { color: "#EE8253", opacity: 1 },
  "&.Mui-selected": { color: "#EE8253", fontWeight: 600 },
}));

export default function TabConfig() {
  const [group, setGroup] = React.useState(0);
  const [sub, setSub] = React.useState(0);
  const dispatch = useDispatch();
  const { enabledPayment } = useCompany();

  dispatch(titleSetRef({ title: "Configurações" }));

  const lojaItems = [
    { label: "App Mobile",          component: <Highlights /> },
    { label: "Lojas",               component: <StoreList /> },
    { label: "Empresa",             component: <Company /> },
    { label: "Tipos de Pagamento",  component: <PaymentTypeList /> },
    { label: "Controle de Acesso",  component: <AccessControl /> },
    ...(enabledPayment ? [{ label: "Operadora Cartão", component: <CardOperator /> }] : []),
  ];

  const GROUPS = [
    {
      label: "Colaboradores",
      items: [
        { label: "Usuários",        component: <UserList /> },
        { label: "Representantes",  component: <UserRepList /> },
      ],
    },
    { label: "Loja", items: lojaItems.filter(i => i.label !== "Controle de Acesso") },
    {
      label: "Produto",
      items: [
        { label: "Categorias",       component: <CategoryList /> },
        { label: "Tamanhos e Cores", component: <ColorsSizes /> },
        { label: "Carrinhos",        component: <CartList /> },
        { label: "Provador Virtual", component: <VirtualOnTryList /> },
      ],
    },
    {
      label: "Sistema",
      items: [
        { label: "Geral",              component: <System section="geral" /> },
        { label: "Controle de Acesso", component: <AccessControl /> },
      ],
    },
  ];

  const handleGroupChange = (_, newGroup) => {
    setGroup(newGroup);
    setSub(0);
  };

  const handleSubChange = (_, newSub) => {
    setSub(newSub);
  };

  const currentItems = GROUPS[group].items;

  return (
    <Box sx={{ width: "100%" }}>
      <Box id="box-header-dash" sx={{ borderBottom: 1, borderColor: "divider" }}>
        {/* Linha 1 — grupos */}
        <Tabs
          value={group}
          onChange={handleGroupChange}
          sx={{
            minHeight: 38,
            "& .MuiTabs-indicator": { backgroundColor: "#EE8253", height: 3 },
            backgroundColor: "#F5F5F5",
          }}
        >
          {GROUPS.map((g, i) => (
            <GroupTab key={i} label={g.label} />
          ))}
        </Tabs>

        {/* Linha 2 — sub-abas do grupo */}
        <Tabs
          value={sub}
          onChange={handleSubChange}
          sx={{
            minHeight: 32,
            "& .MuiTabs-indicator": { backgroundColor: "#EE8253", height: 2 },
          }}
        >
          {currentItems.map((item, i) => (
            <SubTab key={i} label={item.label} />
          ))}
        </Tabs>
      </Box>

      {/* Conteúdo */}
      <Box sx={{ p: 2, pt: "78px" }}>
        {currentItems[sub]?.component}
      </Box>
    </Box>
  );
}
